import { GeneratorModalIndex } from 'common'

// Example for using discriminated union types.
export type ThemeColors = 'light' | 'dark'

// Use enums for better autocompletion of action type names. These will
// be compiled away leaving only the final value in your compiled code.
//
// Define however naming conventions you'd like for your action types, but
// personally, I use the `@@context/ACTION_TYPE` convention, to follow the convention
// of Redux's `@@INIT` action.
export enum ActionTypes {
  SET_THEME = '@@layout/SET_THEME',
  SET_NAVI_WIDTH = '@@layout/SET_NAVI_WIDTH',
  SET_GENERATORMODAL_TOGGLE = '@@layout/SET_GENERATORMODAL_TOGGLE',
  SET_GENERATORMODAL_HIDE = '@@layout/SET_GENERATORMODAL_HIDE',
}

// Declare state types with `readonly` modifier to get compile time immutability.
// https://github.com/piotrwitek/react-redux-typescript-guide#state-with-type-level-immutability
export interface State {
  readonly theme: ThemeColors
  readonly naviSize: number
  readonly generatorModal?: GeneratorModalIndex
}
